import { useState } from 'react';

import Box from '@mui/material/Box';
import IconButton from "@mui/material/IconButton";
import SettingsIcon from '@mui/icons-material/Settings';

import CalendarGroupModal from "@plannel/components/modal/CalendarGroupModal"

const CalendarGroupRenderer = props => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  const { setSnackInfo, editable, calType, readOnly = true } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const [editedCell, setEditedCell] = useState({});

  const isDisable = () => {
    if (editable) {
      if (typeof editable === "function") {
        return !editable(props);
      } else {
        return editable;
      }
    }

    return false;
  }

  const buttonClicked = () => {
    if (!isDisable()) {
      setEditedCell(props);
      setModalOpen(true);
    }
  }

  return (
    <>
      <Box sx={{ display: "flex" }} onDoubleClick={buttonClicked}>
        <Box component={"span"}>{cellValue}</Box>
        <Box component={"span"} sx={{ ml: "auto" }}>
          <IconButton aria-label="settings" size="small" sx={{ verticalAlign: "baseline" }} disabled={isDisable()} onClick={buttonClicked}>
            <SettingsIcon size="small" sx={{ width: "15px", height: "15px" }} />
          </IconButton>
        </Box>
      </Box>
      <CalendarGroupModal
        readOnly={readOnly}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        editedCell={editedCell}
        setSnackInfo={setSnackInfo}
        calType={calType}
      />
    </>
  );
}

export default CalendarGroupRenderer;
